import React from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import api from '../../../components/api';

export interface partnerListData {
  id: number,
  name: string,
  commision: number,
}

function usePartners() {
  const { isLoading, data } = useQuery(['getAll', 'partner'], api.partner.getAll);

  const partnerList = React.useMemo(() => data?.data?.data, [data]);

  const navigate = useNavigate();
  const onNavigateToDetail = (id: string) => navigate(`/partners/${id}`);
  const onNavigateAddPartner = () => navigate('/partners/add');

  return {
    partnerList,
    isLoading,
    onNavigateToDetail,
    onNavigateAddPartner,
  };
}

export default usePartners;
